import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import UseScrollAnimation from "../Elements/ScrollAnimation";
import FormContactUS from "./Page_Sections/formContactUs";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";
import {
  FaFacebook,
  FaInstagram,
  // FaLinkedin,
  // FaTiktok,
  // FaYoutube,
  // FaTwitter,
} from "react-icons/fa";

const ContactUs = () => {
  UseScrollAnimation();

  const details = [
    {
      icon: Phone,
      label: "Phone",
      value: "(610) 412-7940",
      link: "tel:+16104127940",
    },
    {
      icon: Mail,
      label: "Email",
      value: "infotwdhomeo@gmail.com",
      link: "mailto:infotwdhomeo@gmail.com",
      // value: "info@twdhomeo.com",
      // link: "mailto:info@twdhomeo.com",
      // value: "wellnessdestinationhomeopathy@gmail.com",
      // link: "wellnessdestinationhomeopathy@gmail.com",
    },
    {
      icon: MapPin,
      label: "Location",
      value: "Suite 106-H 801 Springdale Dr Exton, PA 19341",
      link: "https://www.google.com/maps?q=Suite+106-H+801+Springdale+Dr+Exton,+PA+19341",
    },
    {
      icon: Clock,
      label: "Hours",
      value: "Mon–Fri • 9am – 5pm",
    },
  ];

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">
                  Contact Us
                </p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Let's begin a conversation.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  Send a message, ask a question, or schedule your consultation.
                  I look forward to hearing from you.
                </p>
              </div>
            </div>
          </section>

          <section className="ContactUs_Section_DetailsFormContent">
            <div className="ContactUs_Section_DetailsFormContentBox">
              {/* Info */}
              <div className="ContactUs_Section_DetailsBox animate-top">
                {details.map((item) => (
                  <div
                    key={item.label}
                    className="ContactUs_Section_DetailsBox_IconDetailsBox animate-top"
                  >
                    <span className="ContactUs_Section_DetailsBox_IconBox">
                      <item.icon
                        className="ContactUs_Section_DetailsBox_Icon"
                        strokeWidth={1.5}
                      />
                    </span>

                    <div className="ContactUs_Section_DetailsBox_IconTextBox">
                      <p className="ContactUs_Section_DetailsBox_IconText_Lable">
                        {item.label}
                      </p>

                      <p className="ContactUs_Section_DetailsBox_IconText_Value">
                        {item.link ? (
                          <a
                            href={item.link}
                            target={
                              item.label === "Location" ? "_blank" : "_self"
                            }
                            rel="noopener noreferrer"
                            className="contact_link"
                          >
                            {item.value}
                          </a>
                        ) : (
                          item.value
                        )}
                      </p>
                    </div>
                  </div>
                ))}
                <div className="ContactUs_Section_DetailsBox_IconDetailsBox">
                  <a
                    href="https://www.instagram.com/p/DXSfegnDtY0/?img_index=3&igsh=MTBpcmsxZmh5YmZrMQ=="
                    className="ContactUs_Section_DetailsBox_IconBox"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram className="ContactUs_Section_DetailsBox_Icon" />
                  </a>
                  <a
                    href="#!"
                    className="ContactUs_Section_DetailsBox_IconBox"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebook className="ContactUs_Section_DetailsBox_Icon" />
                  </a>{" "}
                </div>

                <div className="ContactUs_Section_DetailsBox_LableValueBox animate-top">
                  <p className="ContactUs_Section_DetailsBox_Lable">
                    Not sure where to start?
                  </p>
                  <p className="ContactUs_Section_DetailsBox_Value">
                    Book a complimentary 15-minute discovery call to see if
                    classical homeopathy is the right fit for you.
                  </p>
                </div>
              </div>

              {/* FORM */}
              <FormContactUS />
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default ContactUs;
